"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var en_US_1 = require("./en-US");
exports.enUS = en_US_1.default;
var pt_BR_1 = require("./pt-BR");
exports.ptBR = pt_BR_1.default;
